import { VehicleStatus } from './vehicleStatus';

export const VehicleStatusCategory = {
  ON_GROUND: 'on_ground',
  READY_FOR_TAKEOFF: 'preflight',
  INFLIGHT_NOMINAL: 'inflight_nominal',
  INFLIGHT_FAILURE_MODE: 'inflight_failure_mode',
  WAITING_ON_DOCK: 'waiting_on_dock',
  POSTFLIGHT: 'postflight'
} as const;

export type VehicleStatusCategory = (typeof VehicleStatusCategory)[keyof typeof VehicleStatusCategory];

export function getVehicleStatusBackgroundColor(category: VehicleStatusCategory): string {
  switch (category) {
    case VehicleStatusCategory.ON_GROUND:
      return '#FFF1C2';
    case VehicleStatusCategory.READY_FOR_TAKEOFF:
      return '#CFF7D3';
    case VehicleStatusCategory.INFLIGHT_NOMINAL:
      return '#C2E5FF';
    case VehicleStatusCategory.INFLIGHT_FAILURE_MODE:
      return '#FCB3AD';
    case VehicleStatusCategory.WAITING_ON_DOCK:
      return '#FDE4CE';
    case VehicleStatusCategory.POSTFLIGHT:
      return '#FFF1C2';
  }
}

export function getVehicleStatusForegroundColor(category: VehicleStatusCategory): string {
  switch (category) {
    case VehicleStatusCategory.ON_GROUND:
      return '#B37D00';
    case VehicleStatusCategory.READY_FOR_TAKEOFF:
      return '#009951';
    case VehicleStatusCategory.INFLIGHT_NOMINAL:
      return '#0D74CE';
    case VehicleStatusCategory.INFLIGHT_FAILURE_MODE:
      return '#C00F0C';
    case VehicleStatusCategory.WAITING_ON_DOCK:
      return '#D6761C';
    case VehicleStatusCategory.POSTFLIGHT:
      return '#B37D00';
  }
}

export function getVehicleStatusCategory(status: VehicleStatus): VehicleStatusCategory {
  switch (status) {
    // Inflight failure mode statuses
    case VehicleStatus.SAFING_UP:
    case VehicleStatus.SAFED_UP:
    case VehicleStatus.DESCENDING:
    case VehicleStatus.DESCENDED:
    case VehicleStatus.ABORT_HOME:
    case VehicleStatus.FC_RTL:
    case VehicleStatus.EMERGENCY_LANDING:
    case VehicleStatus.EXECUTING_FALLBACK_MISSION:
    case VehicleStatus.FC_LOSS:
    case VehicleStatus.PARACHUTE_TRIGGERED:
    case VehicleStatus.VEHICLE_DISCONNECTED:
      return VehicleStatusCategory.INFLIGHT_FAILURE_MODE;

    // Ready for takeoff statuses
    case VehicleStatus.READY_FOR_TAKEOFF:
    case VehicleStatus.READY_FOR_TAKEOFF_FROM_DOCK:
      return VehicleStatusCategory.READY_FOR_TAKEOFF;

    // Inflight nominal statuses
    case VehicleStatus.TAKING_OFF:
    case VehicleStatus.INFLIGHT_TO_PICKUP:
    case VehicleStatus.PICKING_UP:
    case VehicleStatus.WAITING_FOR_PACKAGE_LOADED_CONFIRMATION:
    case VehicleStatus.INFLIGHT_TO_DOCK:
    case VehicleStatus.LANDING_ON_DOCK:
    case VehicleStatus.PICKING_UP_FROM_DOCK:
    case VehicleStatus.TAKING_OFF_FROM_DOCK:
    case VehicleStatus.INFLIGHT_TO_DESTINATION:
    case VehicleStatus.INFLIGHT_HOME:
    case VehicleStatus.LANDING_HOME:
    case VehicleStatus.WAITING_FOR_WIRE_DROP_CONFIRMATION:
    case VehicleStatus.PERFORMING_WIRE_DROP:
    case VehicleStatus.HOVERING_PAUSED:
    case VehicleStatus.RC_IN_CONTROL:
      return VehicleStatusCategory.INFLIGHT_NOMINAL;

    // Waiting on dock statuses
    case VehicleStatus.WAITING_ON_DOCK:
      return VehicleStatusCategory.WAITING_ON_DOCK;

    // Postflight statuses
    case VehicleStatus.MISSION_COMPUTER_POSTFLIGHT:
    case VehicleStatus.PENDING_POSTFLIGHT:
      return VehicleStatusCategory.POSTFLIGHT;

    // On ground statuses
    case VehicleStatus.PENDING_MISSION:
    case VehicleStatus.PENDING_PREPARATION:
    case VehicleStatus.PENDING_PREFLIGHT:
      return VehicleStatusCategory.ON_GROUND;

    default:
      return VehicleStatusCategory.ON_GROUND;
  }
}
